import { Modal } from "../../Modal";
import { AlertTriangle } from "react-feather";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isLoading = false,
}: ConfirmationModalProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onConfirm();
    }
  };

  return (
    <Modal
      show={isOpen}
      title={title}
      onClose={onClose}
      className="max-w-md!"
      footer={
        <div
          className="flex justify-end gap-4 w-full"
          onKeyDown={handleKeyDown}
        >
          <button
            type="button"
            className="btn btn-ghost"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="btn btn-error"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading loading-spinner loading-sm" />
            ) : (
              confirmText
            )}
          </button>
        </div>
      }
    >
      <div className="flex items-center gap-4">
        <AlertTriangle className="text-error" />
        <p className="text-base">{message}</p>
      </div>
    </Modal>
  );
}
